import React from 'react';

import NewUpdateUser from 'components/Tvendo/Setting/User/Mantenance/NewUpdateUser';

export default function () {
  return <NewUpdateUser />;
}
